module.exports = __webpack_public_path__ + "img/logo_maker.83bb3cef.png";